import * as Iban from "ibantools";
import { translate } from "../Locales/translator";
import { AbstractValidation } from "./AbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";

export class IbanValidation extends AbstractValidation {
  key = "isIban";

  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: string) => {
    if (!this.required && (value === "" || value === undefined || value === null)) {
      return true;
    }

    return Iban.isValidIBAN(Iban.electronicFormatIBAN(value) || "");
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}MoetEenGeldigIBANZijn", { label: label });
}
